import { useQuery } from '@tanstack/react-query'
import type { Item } from 'typings'
import { useFetch } from './useFetch'
import { SEARCH_TERM_PAGE_SIZE } from './utils'

const page = 1

export function useBrands(searchTerm: string) {
  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/catalog_system/pvt/brand/list/${searchTerm.trim()}`,
    window.location.origin
  )

  const itemsPerPage = searchTerm ? SEARCH_TERM_PAGE_SIZE : 10

  url.search = new URLSearchParams({
    page: String(page),
    pagesize: String(itemsPerPage),
  }).toString()

  async function fetcher() {
    return fetcherWrapper(url)
      .then((r) => r.json())
      .then(
        (r: Item[]) =>
          r
            .map((item) => ({
              name: item.name.trim(),
              id: item.id,
            }))
            .slice(0, itemsPerPage) // brands API does not support pagination when searching
      )
  }

  return useQuery({
    queryKey: ['brands', searchTerm],
    queryFn: fetcher,
  })
}
